<div
  class="grid gap-0"
  [class.h-full]="orientation === 'vertical'"
  [class.w-full]="orientation === 'horizontal'"
  [style]="
    orientation === 'horizontal'
      ? 'grid-template-columns: repeat(' + steps.length + ', 1fr)'
      : 'grid-template-rows: repeat(' + steps.length + ', 1fr)'
  "
>
  @for (step of steps; track $index; let i = $index) {
    <div
      [class]="containerClasses(i)"
      [class.cursor-not-allowed]="isDisabled(i)"
      class="flex"
      [class.flex-col]="orientation === 'horizontal'"
    >
      <div
        class="grid gap-0 items-center justify-center"
        [class.w-full]="orientation === 'horizontal'"
        [class.h-full]="orientation === 'vertical'"
        [style]="
          orientation === 'horizontal'
            ? 'grid-template-columns: 1fr 32px 1fr'
            : 'grid-template-rows: 1fr 32px 1fr'
        "
      >
        <div sag-ui-stepper-line-base [orientation]="orientation">
          <div
            sag-ui-stepper-line
            [orientation]="orientation"
            [attr.data-status]="getState(i)"
          ></div>
        </div>
        <div
          sag-ui-stepper-knob
          [attr.data-status]="getState(i)"
          (click)="!isDisabled(i) && selectedChange.emit(i)"
        >
          <span
            [class]="'icon-' + step.doneIcon"
            *ngIf="step.doneIcon && stepDone(i) && active !== i"
          ></span>
          <span
            [class]="'icon-' + step.icon"
            *ngIf="step.icon && !stepDone(i) && active !== i"
          ></span>
          <span
            [class]="'icon-' + step.invalidIcon"
            *ngIf="step.invalidIcon && isInvalid(i) && active !== i"
          ></span>

          <span
            sag-ui-stepper-knob-indicator
            [attr.data-status]="getState(i)"
            *ngIf="active === i"
          ></span>
        </div>
        <div
          sag-ui-stepper-line-base
          [orientation]="orientation"
          [class.opacity-0]="i === steps.length - 1"
        >
          <div
            sag-ui-stepper-line
            [orientation]="orientation"
            [attr.data-status]="getState(i)"
          ></div>
        </div>
      </div>
      <div
        class="flex items-center justify-center"
        [class.w-full]="orientation === 'horizontal'"
      >
        <span
          sag-ui-stepper-knob-text
          [attr.data-status]="getState(i)"
          [orientation]="orientation"
          *ngIf="step.label"
          >{{ step.label }}</span
        >
      </div>
    </div>
  }
</div>
